<template>
  <div class="app-checkbox">
    <el-checkbox
      ref="input"
      v-model="model"
      :disabled="computedDisabled"
      :class="optionClass"
      :label="computedLabel"
      :true-label="trueLabel"
      :false-label="falseLabel"
      :size="size"
      :border="border"
      @keydown.enter.native="onEnterKey($event)"
      @focus="onFocus"
      @blur="onBlur"
      @change="onChange">
    </el-checkbox>
  </div>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppCheckbox extends AppComponent {
  @Prop({ required: true })
  value;

  @Prop({ required: false })
  placeholder;

  @Prop({ required: false, default: null })
  options;

  @Prop({ required: false, default: false })
  disabled;

  @Prop({ required: false, default: false })
  readonly;

  @Prop({ required: false, default: null })
  label;

  // 次のフォーカス遷移先プロパティ名
  @Prop({ required: false })
  nextFocus;

  /**
   * ボーダー
   */
  get border () {
    return (this.options && 'border' in this.options) ? this.options.border : false;
  }

  /**
   * サイズ
   */
  get size () {
    return (this.options && 'size' in this.options) ? this.options.size : 'medium';
  }

  /**
   * チェック無の場合の値
   * デフォルト:0
   */
  get falseLabel () {
    return (this.options && 'falseLabel' in this.options) ? this.options.falseLabel : 0;
  }

  /**
   * チェック有の場合の値
   * デフォルト:1
   */
  get trueLabel () {
    return (this.options && 'trueLabel' in this.options) ? this.options.trueLabel : 1;
  }

  // ラベル取得
  get computedLabel () {
    return (this.options && 'label' in this.options) ? this.options.label : this.label;
  }

  /**
   * v-model対応
   */
  get model () {
    return this.value;
  }

  /**
   * v-model対応
   */
  set model (value) {
    this.$emit('input', value);
  }

  // クラス
  get optionClass () {
    let optionClass = (this.options && 'class' in this.options) ? this.options.class : [];
    if (this.computedReadonly) {
      if (!Array.isArray(optionClass)) {
        optionClass = [optionClass];
      }
      optionClass.push('is-readonly');
    }
    return optionClass;
  }

  /**
   * readonly
   */
  get computedReadonly () {
    // プロパティ優先
    if (this.readonly === true || this.readonly === 'true') {
      return true;
    }
    const readonly = (this.options && 'readonly' in this.options) ? this.options.readonly : false;
    return readonly;
  }

  /**
   * disabled
   */
  get computedDisabled () {
    // プロパティ優先
    if (this.disabled === true || this.disabled === 'true') {
      return true;
    }
    const disabled = (this.options && 'disabled' in this.options) ? this.options.disabled : false;
    return disabled || this.computedReadonly;
  }

  // 親コンポーネントへの透過イベント
  onChange (...args) {
    this.$emit('app-event', 'change', this, ...args);

    // 値が変更されたタイミングでバリデーションを要求する
    this.$emit('app-event', 'require:validate', this, ...args);
  }

  // 親コンポーネントへの透過イベント
  onFocus (...args) {
    this.$emit('app-event', 'focus', this, ...args);
  }

  // 親コンポーネントへの透過イベント
  onBlur (...args) {
    this.$emit('app-event', 'blur', this, ...args);
  }

  // エンターキーイベント
  onEnterKey (event) {
    this.$emit('app-event', 'enterkey', event, this);
  }

  // フォーカス設定
  focus () {
    this.$refs.input.$el.getElementsByTagName('input')[0].focus();
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/checkbox/AppCheckbox.vue